// Sidebar navigation component
import {
    Box,
    Flex,
    Image,
    Tooltip,
    useBreakpointValue,
    Button,
    Icon,
    Link as ChakraLink,
    Center,
    VStack,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { GiArchiveResearch } from "react-icons/gi";
import { Link as RouterLink, matchPath, useLocation, useNavigate } from 'react-router-dom';
import { LuPenTool } from "react-icons/lu";
import { IoIosHelpCircle, IoIosInformationCircle } from "react-icons/io";
import { useRecoilState } from "recoil";
import { leftDrawerOpenStatus } from "../../atoms/rootAtom";
import { pxToRem } from "../../utils/editor.ts";
import { useState } from "react";

const SideNav = () => {
    const { t } = useTranslation();
    const location = useLocation();
    // const isMobile = useBreakpointValue({ base: true, md: true, lg: true, xl: false });
    console.log(useBreakpointValue({ base: true, md: true, lg: true, xl: false }))
    const isMobile = false
    const isCurrentPathMyDrive = location.pathname === "/my-library";
    const navigate = useNavigate();
    const [, setDrawerOpenStatus] = useRecoilState(leftDrawerOpenStatus);
    const [hoverIndex, setHoverIndex] = useState<number>(-1);

    // 根据环境变量动态生成review URL
    const getReviewUrl = () => {
        const isDevelopment = import.meta.env.MODE === 'development';
        if (isDevelopment) {
            return 'https://api.dev.doenba.ai/edit-api/doenba_paper_review/upload/';
        } else {
            return 'https://api.stage.doenba.ai/edit-api/doenba_paper_review/upload/';
        }
    };

    const menus = [
        // {
        //     link: '/search',
        //     label: 'mini-nav-tasksearch',
        //     description: 'mini-nav-tasksearch-description',
        //     mobileIcon: Search2Icon
        // },
        {
            link: '/read',
            label: 'mini-nav-read-analyze',
            description: 'mini-nav-read-analyze-description',
            mobileIcon: GiArchiveResearch,
            img: 'left-read.svg',
            activeImg: 'left-read-active.svg'
        },
        {
            link: '/edit',
            label: 'mini-nav-editor',
            description: 'mini-nav-editor-description',
            mobileIcon: LuPenTool,
            img: 'left-edit.svg',
            activeImg: 'left-edit-active.svg',
        },
        {
            link: getReviewUrl(),
            label: 'mini-nav-review',
            description: 'mini-nav-review-description',
            mobileIcon: LuPenTool,
            img: 'left-review.png',
            activeImg: 'left-review-active.png'
        },
        // {
        //     link: '/editor',
        //     label: 'mini-nav-paper-review',
        //     description: '',
        // }
        // {
        //     link: '/read/notes',
        //     label: 'mini-nav-notes',
        //     description: 'mini-nav-notes-description',
        //     mobileIcon: GiArchiveResearch
        // }
    ]

    const matchingTabIndex = menus.findIndex(tab => matchPath(tab.link, location.pathname));

    const logoOnClick = () => {
        navigate('/edit')
    }

    return (
        <>
            <Flex flexDir={'column'} minW={isMobile ? '60px' : pxToRem(260)} justifyContent={'space-between'} h={'full'} borderRight={'2px solid white'}>
                <Flex flexDir={'column'} h={'full'}>
                    {!isMobile &&
                        <Center pt={5} mb={pxToRem(69)} mt={pxToRem(20)} onClick={logoOnClick}>
                            <Image
                                w={pxToRem(178)}
                                objectFit='cover'
                                src='/static/doenba-logo.svg'
                                alt='Doenba'
                            />
                        </Center>
                    }
                    {isMobile &&
                        <Center pt={5} onClick={logoOnClick}>
                            <Image
                                w={'35px'}
                                objectFit='cover'
                                src='/static/doenba-ico-blue.png'
                                alt='Doenba'
                            />
                        </Center>
                    }
                    <Flex flexDir={'column'} justifyContent={'space-between'} h={'full'}>
                        <Box>
                            {isCurrentPathMyDrive &&
                                <Flex flexDir='column'>
                                    {menus.map((menu, index) => (
                                        <Button mb={2} colorScheme="blue" key={menu.link}
                                                variant={matchingTabIndex === index ? 'solid' : 'ghost'}>
                                            <ChakraLink as={RouterLink} to={menu.link}>
                                                <Tooltip label={t(menu.description)} placement='bottom'>
                                                    <Image src={`/static/${menu.img}`} />
                                                    {t(menu.label)}
                                                </Tooltip>
                                            </ChakraLink>
                                        </Button>
                                    ))}
                                </Flex>
                            }
                            {!isCurrentPathMyDrive &&
                                <Flex flexDir='column'>
                                    {!isMobile && menus.map((menu, index) => (
                                      <ChakraLink textAlign={'right'} mb={pxToRem(40)} width={pxToRem(224)} as={RouterLink}
                                                  borderLeft={matchingTabIndex === index ? '3px solid #1D8AFF' : 'none'}
                                                  boxSizing={'border-box'}
                                                  to={menu.link} key={menu.link} textDecoration="none"  _hover={{ textDecoration: 'none' }}>
                                          <Tooltip p={3} borderRadius={pxToRem(5)} label={t(menu.description)} placement='right'>
                                            <Button
                                                    width={pxToRem(210)}
                                                    height={pxToRem(50)}
                                                    borderRadius={pxToRem(10)}
                                                    fontSize={pxToRem(18)}
                                                    fontFamily={'Lato'}
                                                    px={4}
                                                    ml={pxToRem(16)}
                                                    display="flex"
                                                    alignItems="center"
                                                    pl={'1rem'}
                                                    _hover={{ bg: '#1D8AFF', color: '#FFF' }}
                                                    bg={matchingTabIndex === index ? '#1D8AFF' : 'transparent'}
                                                    color={matchingTabIndex === index ? '#FFFFFF' : '#1D8AFF'}
                                                    onMouseOver={() => {
                                                        setHoverIndex(index)
                                                    }}
                                                    onMouseLeave={() => {
                                                        setHoverIndex(-1) // 鼠标离开时重置hoverIndex
                                                    }}
                                            >
                                                {menu.img && <Box minW={pxToRem(24)} width={pxToRem(24)} h={pxToRem(24)} display="flex" alignItems="center" mr={2}
                                                background={`url("/static/${hoverIndex === index || matchingTabIndex === index ? menu.activeImg : menu.img}")`} bgSize={'100% 100%'}
                                                >

                                                </Box>}
                                                <Box flex="1" textAlign="left" textDecoration="none" whiteSpace="nowrap">{t(menu.label)}</Box>
                                            </Button>
                                          </Tooltip>
                                      </ChakraLink>
                                    ))}
                                    {isMobile && menus.map((menu, index) => (
                                        <Button mb={2} colorScheme="blue" variant={matchingTabIndex === index ? 'solid' : 'ghost'} key={menu.link} _selected={{ bg: '#1D8AFF', border: '1px solid #1D8AFF', borderRadius: '5px', fontWeight: '600', color: 'white' }}>
                                            <ChakraLink as={RouterLink} to={menu.link} pb={0}>
                                                <Tooltip label={t(menu.description)} placement='bottom'>
                                                    <span>
                                                        <Icon as={menu.mobileIcon} />
                                                    </span>
                                                </Tooltip>
                                            </ChakraLink>
                                        </Button>
                                    ))}
                                </Flex>
                            }
                        </Box>
                        <VStack py={12}>
                            {!isMobile &&
                                <>
                                    <ChakraLink
                                      _hover={{ textDecoration: 'none' }}
                                      mb={5}
                                      onClick={() => setDrawerOpenStatus(true)}>{t('editor-editormodel-leftTutorial')}</ChakraLink>
                                    <Center mt={4}>
                                        <ChakraLink
                                            _hover={{ textDecoration: 'none' }}
                                            onClick={() => navigate('/support')}
                                           >
                                        Support
                                        </ChakraLink>
                                    </Center>
                                    {/*<ChakraLink onClick={() => setDrawerOpenStatus(true)} variant="underline">Help</ChakraLink>*/}
                                </>
                            }
                            {isMobile &&
                                <>
                                    <ChakraLink mb={5} onClick={() => setDrawerOpenStatus(true)} variant="underline">
                                        <IoIosInformationCircle color="#0057ec" />
                                    </ChakraLink>
                                    <ChakraLink onClick={() => setDrawerOpenStatus(true)} variant="underline">
                                        <IoIosHelpCircle color="#0057ec" />
                                    </ChakraLink>
                                </>
                            }
                        </VStack>
                    </Flex>
                </Flex>
            </Flex>
        </>
    );
}

export default SideNav;